function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'0d3d238b089a67e34e39b5abf80db19b': 'rgb(255, 0, 0)','0273dad9bd60b0c0c369597118216a35': 'rgb(0, 0, 255)','0055dca5a1bb5f011661eab6440936ef': 'rgb(64, 69, 79)','e4a9f7548fed785e3e047d7f300eba4e': 'rgb(105, 151, 171)','51fbef11522f60196537b8b938d3c54c': 'rgb(24, 37, 51)','cd683768f1a31386e74f8af978266970': 'rgb(0, 153, 38)','7b58da14600257648f7a58cf20361245': 'rgb(211, 178, 141)','2d657511b2864abb158b00ab759e030b': 'rgb(245, 179, 36)','eb44a981f131752f84c63e435f4f98bd': 'rgb(249, 195, 198)','d508fe45cecaf653904a0e774084bb5c': 'rgb(255, 255, 255)','a8bba0ac9999dbc8c61175fc03f5b6d7': 'rgb(125, 5, 24)','35de73f175ef2af25d4b4f2178d06d95': 'rgb(249, 195, 198)','2a7911843fd2d052ed374e70412e883f': 'rgb(24, 37, 51)','cecd2b69d5250f74ea2939518c00f83a': 'rgb(56, 63, 63)','6a212e762dd17298f59a6bbb2854e6a6': 'rgb(182, 125, 67)','4e1f60f851575124e4dbd400f18e2936': 'rgb(211, 178, 141)','2dacec948895e366b2d4293aca50fd72': 'rgb(245, 179, 36)','ee9eae1a6e5ad117ca783e217ae89370': 'rgb(68, 190, 231)','9ef887d6a3cb8f3360cb29b7349e25bf': 'rgb(86, 108, 156)',};

    this.images = {};
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) swatch.style.setProperty('--tick-color', '#000');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

window.theme.swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  window.theme.swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);
